export const profitMarginReport = {
	seeMore: "Mostrar Más",
	pageTitle: "Informe de Costos y Márgenes de Ganancia",
	empty: "No hay informes disponibles",
	label: "Costos y margen de ganancia",
	notAssociatedReport: "(Informe no asociado)",
	export: "Descargar en Excel",
	print: "Imprimir",
	selectPlaceholder: "Seleccione aquí",
	excelFileName: "informe_costo_y_margenes_de_ganancia",
	successfullExportMsg: "Informe exportado con éxito",
	period: "Período",
	header: {
		description:
			"Este informe ofrece una visión del desempeño financiero de los productos mostrando su facturación, cantidad vendida, precio de venta, costos y margen de ganancia.",
	},
	columns: {
		productName: "Producto",
		category: "Categoría",
		quantity: "CANT.",
		value: "Precio promedio",
		soldAmount: "Facturación",
		invoicing: "Participación",
		invoicingExplanation: "Porcentaje del producto en la facturación",
		averageSellingPrice: "Costo Unitario",
		totalCost: "Costo total",
		costPercentage: "% Costo",
		costPercentageExplanation: "Porcentaje del producto en el costo",
		profitMarginValue: "$ Ganancia",
		profitMarginValueExplanation: "Margen de ganancia en dinero",
		profitMarginPercentage: "% Ganancia",
		profitMarginPercentageExplanation: "Margen de ganancia en porcentaje",
	},
	indicators: {
		updatedAt: "Actualizado {{ date }}",
		profitMargin: {
			title: "Margen de Ganancia",
		},
		totalBilling: {
			title: "Facturación Total",
		},
		totalCost: {
			title: "Costo Total",
		},
		mostProfitMargin: {
			title: "Mayor Margen de Ganancia",
			seeMore: "Productos con mayor margen de ganancia",
		},
		lessProfitMargin: {
			title: "Menor Margen de Ganancia",
			seeMore: "Productos con menor margen de ganancia",
		},
	},
	flags: {
		red: "Entre los 5 productos con menor margen de ganancia",
		green: "Entre los 5 productos con mayor margen de ganancia",
	},
	filters: {
		period: "Período",
		product: "Producto",
		category: "Categoría",
		allProducts: "Todos los productos",
		allCategories: "Todas las categorías",
	},
};
